<template lang="html">
  <div class="license-component">
    <h2 class="text-center">Vezetői engedély adatok</h2>
    <br>
    <v-container>
      <v-progress-linear
            v-if="preloader"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-form
        ref="diak_license_form"
        v-model="valid"
        lazy-validation
        v-show="!preloader"
      >
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
          v-model="license_number"
          label="Vezetői engedély száma"
          :rules="[rules.required]"
          outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-if="contract_type != 4 || contract_type == null"
            v-model="issuer_country"
            :items="country_list"
            item-text="country"
            item-value="code"
            label="Kibocsátó ország"
            :rules="[rules.required]"
            outlined
          ></v-select>
          <v-autocomplete
            v-if="contract_type == 4"
            v-model="gki_issuer_country"
            :items="gki_country_list"
            item-text="Megnevezes"
            item-value="Azonosito"
            label="Kibocsátó ország"
            :rules="[gkiLicenseRule]"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="medical_suitability_group"
            :items="medical_group"
            item-text="med_group"
            item-value="code"
            label="Egészségügyi csoport kódja"
            :rules="[rules.required]"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
          v-model="restriction_code"
          label="Korlátozás kódja"
          outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="subtitle-1">Kategóriák</div>
      <v-divider></v-divider><br>
      <v-card
        v-for="(license, index) in license_details" v-bind:key="index"
        outlined
        shaped
        class="mb-2"
      >
      <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-select
            v-model="license.course_type_id"
            :items="category_list"
            item-text="category"
            item-value="category"
            label="Kategória"
            :rules="[rules.required]"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
          v-model="license.issue_date"
          label="Vizsgadátum"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          :rules="[rules.required]"
          outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
          v-model="license.validity_date"
          label="Érvényesség"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          :rules="[rules.required]"
          outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
        <v-btn @click="removeLicenseLine(index, license.line_id)" color="red" outlined class="mt-2">
          törlés
        </v-btn>
        </v-col>
        </v-row>
        </v-card-text>
      </v-card>
      </v-form>
      <v-row>
        <v-col cols="5">
        <v-btn
          color="primary"
          @click="addLicenseLine"
          rounded
          class="mr-3"
        >
        Hozzáad
        <v-icon dark right>mdi-plus</v-icon>
        </v-btn>
        </v-col>
        <v-col cols="5">
        <v-btn
          color="primary"
          @click="save_license_dialog = true"
          rounded
          class="mr-3"
        >
        Rögzít
        <v-icon right dark>save</v-icon>
        </v-btn>
        </v-col>
        <v-col cols="5">
        <v-btn
          color="red"
          @click="getLicenseDetails"
          rounded
          outlined
          class="mr-3"
        >
        Mégsem
        <v-icon right dark>undo</v-icon>
        </v-btn>
        </v-col>
      </v-row>
      <br>
      <div>
        <div class="subtitle-1">Meglévő GKI kártya adatai</div>
        <v-divider></v-divider><br>
        <v-form
          ref="gki_card_form"
          v-model="gki_valid"

        >
        <v-card
          outlined
          shaped
          class="mb-2"
        >
        <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
            v-model="gki_card_number"
            label="Száma"
            outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
            v-model="gki_issue_date"
            label="Kiállítás dátuma"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            outlined
            :rules="[gkiCardRules]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
            v-model="gki_validity_date"
            label="Érvényesség vége"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            outlined
            ></v-text-field>
          </v-col>
        </v-row>
        </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12" sm="6" md="4">
          <v-btn
            color="primary"
            rounded
            class="mr-3"
            :disabled="!license_head_id || !gki_valid"
            @click="saveGKICard"
          >
          Rögzít
          <v-icon right dark>save</v-icon>
          </v-btn>
          </v-col>
        </v-row>
        </v-form>
        <p v-if="!license_head_id">Vezetői engedély adatok nélkül nem rögzíthető!</p>
      </div>
    </v-container>

    <v-dialog v-model="save_license_dialog" persistent max-width="300">
      <v-card>
        <v-card-text class="pt-4">Biztosan menteni szeretné az adatokat?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="validate(), save_license_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="save_license_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="save_license_snackbar" bottom>
      {{save_license_response}}
      <v-btn color="pink" text @click="save_license_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>

import {
  mapFields
} from 'vuex-map-fields'

  export default {
    data () {
      return {
        license_details: [],
        license_number: '',
        license_head_id: '',
        country_list: [],
        issuer_country: '',
        medical_group: [],
        medical_suitability_group: '',
        restriction_code: '',
        category_list: '',
        rules: {
            required: value => !!value || 'Kötelező mező!',
        },
        valid: true,
        delete_lines: [],
        save_license_dialog: false,
        save_license_snackbar: false,
        save_license_response: '',
        gki_card_number: '',
        gki_issue_date: '',
        gki_validity_date: '',
        gki_valid: true,
        gki_country_list: [],
        gki_issuer_country: '',
      }
    },
    methods: {
      getLicenseDetails: async function() {
        this.preloader = true
        this.contracts = null
        this.license_number = null
        this.issuer_country = null
        this.medical_suitability_group = null
        this.restriction_code = null
        this.license_head_id = null
        this.gki_card_number = null
        this.gki_issue_date = null
        this.gki_validity_date = null
        await this.gettoken()
        this.$http.post('/adatok/license_details_20210318', {
          token: this.token
        }).then((response) => {
          this.preloader = false
          this.license_details = response.data['license_lines']
          this.license_head_id = response.data['license_head'][0]['head_id']
          this.license_number = response.data['license_head'][0]['serial_number']
          this.issuer_country = response.data['license_head'][0]['issuer_country']
          this.gki_card_number = response.data['license_head'][0]['gki_card_number']
          this.gki_issue_date = response.data['license_head'][0]['gki_issue_date']
          this.gki_validity_date = response.data['license_head'][0]['gki_validity_date']
          if (response.data['license_head'][0]['issuer_country'] == null) {
            this.issuer_country = 'H'
          }
          this.medical_suitability_group = response.data['license_head'][0]['medical_suitability_group']
          this.restriction_code = response.data['license_head'][0]['restriction_code']
          this.gki_issuer_country = response.data['license_head'][0]['gki_issuer_country']
        }, (error) => {
          console.log(error.data);
        })
      },
      getCountryList() {
        this.preloader = true
        this.$http.get('/wsdl/dlcountry'
        ).then((response) => {
          this.preloader = false
          this.country_list = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getCategoryList() {
        this.preloader = true
        this.$http.get('/wsdl/dlcategory'
        ).then((response) => {
          this.preloader = false
          this.category_list = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getGKICountryList() {
        this.preloader = true
        this.$http.get('/adatok/gki_issuer_countries'
        ).then((response) => {
          this.preloader = false
          this.gki_country_list = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getMedGroup() {
        this.preloader = true
        this.$http.get('/wsdl/dlmedgroup'
        ).then((response) => {
          this.preloader = false
          this.medical_group = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      addLicenseLine() {
        if (this.license_details != '') {
          this.license_details.push({
            course_type_id: null,
            issue_date: null,
            validity_date: this.license_details[0]['validity_date']
          })
        } else {
          this.license_details.push({
            course_type_id: null,
            issue_date: null,
            validity_date: null
          })
        }
      },
      removeLicenseLine (lineId, dbid) {
        this.license_details.splice(lineId, 1)
        this.delete_lines.push({
          line_id: dbid,
        })
        console.log(this.delete_lines);
      },
      saveLicenseDetails: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/save_license_details', {
          token: this.token,
          head_id: this.license_head_id,
          license_details: this.license_details,
          license_number: this.license_number,
          issuer_country: this.issuer_country,
          medical_suitability_group: this.medical_suitability_group,
          restriction_code: this.restriction_code,
          delete_lines: this.delete_lines
        }).then((response) => {
          this.save_license_response = response.data
          this.save_license_snackbar = true
          this.preloader = false
          this.getLicenseDetails()
          this.delete_lines = []
        }, (error) => {
          console.log(error.data);
        })
      },
      saveGKICard: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/save_gki_card', {
          token: this.token,
          head_id: this.license_head_id,
          gki_card_number: this.gki_card_number,
          gki_issue_date: this.gki_issue_date,
          gki_validity_date: this.gki_validity_date
        }).then((response) => {
          this.save_license_response = response.data
          this.save_license_snackbar = true
          this.preloader = false
          this.getLicenseDetails()
          this.delete_lines = []
        }, (error) => {
          console.log(error.data);
        })
      },
      validate () {
        if (this.$refs.diak_license_form.validate()) {
          //this.save_student_dialog = true
          this.saveLicenseDetails()
          }
        },
      resetValidation () {
          this.$refs.diak_license_form.resetValidation()
        },
    },
    mounted() {
      this.getCountryList()
      this.getMedGroup()
      this.getCategoryList()
      this.resetValidation()
      this.getGKICountryList()
      this.getLicenseDetails()
    },
    watch: {
      customer_id: function(value) {
        if (value) {
          this.getCountryList()
          this.getMedGroup()
          this.getCategoryList()
          this.resetValidation()
          this.getLicenseDetails()
        }
      },
      license_details () {
          this.resetValidation()
      },
    },
    computed: {
    ...mapFields([
      'actions.preloader',
      'ids.customer_id',
      'ids.customer_name',
      'ids.contract_type',
    ]),
    gkiCardRules: function () {
      if (this.gki_card_number && !this.gki_issue_date) {
        !this.gki_valid
        return "Kötelező mező!"
      } else {
        return true
      }
    },
    gkiLicenseRule() {
      if (!this.gki_issuer_country) {
        !this.valid
        return "Kötelező mező!"
      } else {
        return true
      }
    }
  },
  }
</script>

<style lang="css">
</style>
